import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {dbGetHighlight, getCardById, updateCard, updateHighlight, updateTranscript} from "../../../model";
import {postMessage, recvMessage, unSubscribe} from "../../common/event";
import {
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_PDF_ANNO_COMMENT, EVENT_REFRESH_VIDEO_ANNO_ELEMENT,
    EVENT_REFRESH_VIDEO_NOTE,
    FROM_DIALOG, KEY_FILE_DIR, MAX_Z_INDEX
} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {IconClose, IconLocation, IconUndo} from "../../Icon";
import {Button, Dropdown, Form, Input, InputRef, message, Modal, Popover, Switch, TimePicker} from "antd";
import {t} from "i18next";
import {
    base64ToBlob,
    createCopyLinkByLibraryItem, extFromMineType, generateUUID2, getAudioFilterExt, getFileNameExt,
    getImagePathWithTheme,
    getItem,
    getLocalFilePath, getVideoSnapShotByVideo,
    imgPathPerfix, isAudio, isBilibiliUrl,
    isDarkMode, isSupportVideoAnnoUrl, isVideo, isYoutubeUrl
} from "@/utils";
import YouTube, {YouTubePlayer, YouTubeProps} from "react-youtube";
import {pauseAllVideo} from "@/Utility";
import dayjs from "dayjs";
import {createLibraryItemMenu} from "@/MenuUtils";
import VideoOtherContent from "../../../@excalidraw/packages/excalidraw/components/VideoNotes/VideoOtherContent";
import CustomAudio from "../../../@excalidraw/packages/excalidraw/components/Audio/CustomAudio";
import {getSeconds, getSpecificTimeOfDay, importTranscriptFromContent} from "@/VideoHighlightUtils";
import {copyImageToClipboard} from "@/Utility0";
import global from "@/global";

const DialogVideoAnno = forwardRef((props:{onClose:any}, ref) => {

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [annoData,setAnnoData] = useState<any>(null);
    const [videoData,setVideoData] = useState<any>(null);
    const youtubeRef: YouTubePlayer = useRef(null);
    const localVideoRef = useRef<any>(null);
    const videoOtherContentRef = useRef(null);
    const customAudioRef = useRef(null);
    const [isLoading,setIsLoading] = useState(true);
    const disabledTime = useRef<any>(null);
    const inputRef = useRef<InputRef>(null);
    const [arrayMenu,setArrayMenu] = useState([]);

    const txtTitleRef = useRef(null);
    const txtContentRef = useRef(null);
    const isFirst = useRef(true);

    const [isMouseEnterCapture,setIsMouseEnterCapture] = useState(false);
    const [endTime,setEndTime] = useState<any>(0);
    const [isPopoverEndTimeOpen,setIsPopoverEndTimeOpen] = useState(false);
    const [hasLoop,setHasLoop] = useState(false);
    const [capturePath,setCapturePath] = useState('');
    const intervalRef = useRef<any>(0)

    const mEndTimeRef = useRef(0);
    const mHasLoopRef = useRef(false);
    const mAnnoDataRef = useRef(null);

    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    useEffect(() => {
        recvMessage(EVENT_REFRESH_VIDEO_NOTE,(msg,data)=>{
            if (data.data.id == annoData?.id){
                getCardById(data.data.id)?.then(res=>{
                    setAnnoData(res);
                })
            }
        })

        if (isSupportVideoAnnoUrl(annoData?.src) && isFirst.current){
            setSelectTime();
            isFirst.current = false;
        }
        mAnnoDataRef.current = annoData;
        // unSubscribe(EVENT_REFRESH_VIDEO_NOTE);
    },[annoData]);

    useEffect(()=>{
        if (isAudio(videoData?.fileName) && isFirst.current){
            setSelectTime();
            isFirst.current = false;
        }
    },[videoData]);

    useEffect(() => {
        global.g_showDialogs.dialogVideoAnno = true;
        return ()=>{
            window.globalRefreshList('refresh_single_library_item_',mAnnoDataRef.current?.id);
            global.g_showDialogs.dialogVideoAnno = false;
        }
    }, []);

    useEffect(()=>{
        mHasLoopRef.current = hasLoop;
        mEndTimeRef.current = endTime;
    },[hasLoop,endTime])

    const onShowDialog = (libraryData:any)=>{
        setIsShowDialog(true);
        setAnnoData(libraryData);
        setEndTime(dayjs(libraryData.endTime));
        setHasLoop(libraryData.loop);
        setCapturePath(libraryData.thumbImage);

        setArrayMenu(createLibraryItemMenu('',false,libraryData))
        if (!libraryData.src){
            //本地视频...
            getCardById(libraryData.libraryId)?.then(res=>{
                setVideoData(res);
            })
        }

        isFirst.current = true;

        intervalRef.current = setInterval(async ()=>{
            if (youtubeRef.current){
                if (mEndTimeRef.current){
                    let nCurTime = youtubeRef.current.getCurrentTime();
                    let nStartTime = getSeconds(mAnnoDataRef.current?.time);
                    let nEndTime = getSeconds(mEndTimeRef.current);

                    if (nCurTime >= nEndTime){
                        youtubeRef.current?.seekTo(nStartTime);
                        if (!mHasLoopRef.current){
                            youtubeRef.current.pauseVideo();
                        }
                    }
                }
            }else if (videoOtherContentRef.current){
                if (mEndTimeRef.current){
                    let nCurTime = await videoOtherContentRef.current.onGetCurrentTime();
                    let nStartTime = getSeconds(mAnnoDataRef.current?.time);
                    let nEndTime = getSeconds(mEndTimeRef.current);

                    if (nCurTime >= nEndTime){
                        await videoOtherContentRef.current?.onSetCurrentTime(nStartTime);
                        if (!mHasLoopRef.current){
                            videoOtherContentRef.current.onPauseVideo();
                        }
                    }
                }
            }
        },1000)
    }


    const handleMenuClick = async (event:any)=>{
        const szAction = event.key;
        const item = annoData;
        if (szAction == 'locateHighlight'){
            setIsShowDialog(false);
            await saveToDb();
            const highlight = await dbGetHighlight(item.libraryId);
            if (highlight) {
                window.showVideoNotes(highlight,item.id)
            }
        }else if (szAction == 'changeSource'){
            changeSourceEvent(item);
        }else if (szAction == 'showInfo'){
            window.showInfo('library',item);
        }else if (szAction == 'copyLink'){
            createCopyLinkByLibraryItem(item);
        }else if (szAction == 'managerTags'){
            //管理标签
            window.showManageTags([item]);
        }else if (szAction == 'addToProject'){
            //添加到project.
            window.showDialogChooseProject([item]);
        }else if (szAction == 'delete'){
            //删除，关闭
            annoData.isDeleted = 1;
            const newData = {...annoData,isDeleted:1};
            setAnnoData(newData);
            setIsShowDialog(false);//关闭自动更新
        }
    }

    /**
     * 更改source
     */
    const changeSourceEvent = (item:any)=>{
        //选择的
        const arrayChecked:any = [];
        if (item){
            arrayChecked.push(item);
        }
        let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg']}];
        if (item.type == 'audioAnno'){
            filter = [{ name: 'Audio', extensions: getAudioFilterExt()}];
        }
        ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
            if (res){
                for (let i=0;i<arrayChecked.length;i++){
                    let item = arrayChecked[i];
                    if (item.type == 'video' || item.type == 'pdf' || item.type == 'audio' || item.type == 'videoAnno' || item.type == 'pdfAnno' || item.type == 'audioAnno'){
                        if (item.type == 'pdfAnno' || item.type == 'videoAnno' || item.type == 'audioAnno'){
                            item = await getCardById(item.libraryId);
                        }
                        if (item.type == 'pdf' || item.type == 'video' || item.type == 'audio'){
                            item.isAbsolutePath = true;
                            item.fileName = res;
                            await updateCard(item);

                            if (!annoData.src){
                                //本地视频...
                                const newVideoData = {...item};
                                setVideoData(newVideoData);
                            }
                        }
                    }
                }
            }
        })
    }

    const getCurrentHoursMinutesSeconds = (seconds: number) => {
        const currentHours = Math.floor(seconds / 3600);
        const currentMinutes = Math.floor((seconds % 3600) / 60);
        const currentSeconds = Math.floor(seconds % 60);
        return {
            currentHours,
            currentMinutes,
            currentSeconds,
        };
    };

    const getRemainingHoursMinutesSeconds = (seconds: number) => {
        const { currentHours, currentMinutes, currentSeconds } =
            getCurrentHoursMinutesSeconds(seconds);

        const remainingHoursRange = Array.from(
            { length: 24 - currentHours - 1 },
            (_, i) => i + currentHours + 1,
        );
        const remainingMinutesRange = Array.from(
            { length: 60 - currentMinutes - 1 },
            (_, i) => i + currentMinutes + 1,
        );
        const remainingSecondsRange = Array.from(
            { length: 60 - currentSeconds - 1 },
            (_, i) => i + currentSeconds + 1,
        );

        return {
            remainingHoursRange,
            remainingMinutesRange,
            remainingSecondsRange,
        };
    };

    const onPlayerReadyYoutube: YouTubeProps["onReady"] = (event) => {
        youtubeRef.current = event.target;
        setIsLoading(false);
        event.target.pauseVideo();
        const iframe = event.target.getIframe() as HTMLIFrameElement;
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        const duration = event.target.getDuration(); //秒

        const remaining = getRemainingHoursMinutesSeconds(duration);

        disabledTime.current = {
            disabledHours: () => remaining.remainingHoursRange,
            disabledMinutes: () => remaining.remainingMinutesRange,
            disabledSeconds: () => remaining.remainingSecondsRange,
        };

        //设置name
        if (youtubeRef.current?.videoTitle){
            var newData = {...annoData};
            newData.name = youtubeRef.current?.videoTitle;
            setAnnoData(newData);
        }

        setSelectTime();
    };

    const onPlayerReadyLocal = (event: React.SyntheticEvent<HTMLVideoElement>) => {
        if (disabledTime.current) {
            return;
        }

        //  @ts-ignore
        localVideoRef.current = event.target;
        localVideoRef.current!.pause();
        const duration = localVideoRef.current!.duration;
        const remaining = getRemainingHoursMinutesSeconds(duration);
        disabledTime.current = {
            disabledHours: () => remaining.remainingHoursRange,
            disabledMinutes: () => remaining.remainingMinutesRange,
            disabledSeconds: () => remaining.remainingSecondsRange,
        };
        setSelectTime();
    };

    const seekTo = (hours,minutes,seconds)=>{
        if (youtubeRef.current){
            youtubeRef.current?.seekTo(hours * 3600 + minutes * 60 + seconds);
        }else if (videoOtherContentRef.current){
            videoOtherContentRef.current?.reloadIframe(hours * 3600 + minutes * 60 + seconds);
        }else if (customAudioRef.current){
            customAudioRef.current.onSetCurrentTime(hours * 3600 + minutes * 60 + seconds);
        }
        else{
            localVideoRef.current!.currentTime =
                hours * 3600 + minutes * 60 + seconds;
        }
    }
    /**
     * 选中时间
     */
    const setSelectTime = ()=>{
        const dayjsObject = dayjs(annoData?.time);
        const hours = dayjsObject.hour();
        const minutes = dayjsObject.minute();
        const seconds = dayjsObject.second();
        seekTo(hours,minutes,seconds);
    }

    const onChangeTimePicker = (time: any) => {
        const hours = time.hour();
        const minutes = time.minute();
        const seconds = time.second();

        var newData = {...annoData};
        newData.time = dayjs(time).toDate().getTime();
        setAnnoData(newData);

        seekTo(hours,minutes,seconds);
    };

    //保存到数据库
    const saveToDb = ()=>{
        return new Promise(resolve => {
            var newData = {...annoData};
            let nEndTime = 0;
            if (endTime){
                nEndTime = endTime.toDate().getTime();
            }
            newData.endTime = nEndTime;
            newData.loop = hasLoop;
            newData.thumbImage = capturePath;
            updateCard(newData).then(res => {
                // postMessage(EVENT_REFRESH_LIBRARY_LIST);
                window.globalRefreshList('refresh_single_library_item_',mAnnoDataRef.current?.id);
                window.globalRefreshList('refresh_tableview_single_data_',mAnnoDataRef.current?.id);
                postMessage(EVENT_REFRESH_VIDEO_ANNO_ELEMENT, {...newData,thumbImage:capturePath,loop:hasLoop,endTime:endTime});
                //这里继续保存到highlight表
                dbGetHighlight(res.libraryId).then(r=>{
                    if (r){
                        //更新这个注记
                        const data = r.data.find(p=>p.id == annoData.id);

                        if (data){
                            data.time = annoData.time;
                            data.title = annoData.title;
                            data.content = annoData.content;
                            data.updateTime = annoData.updateTime;
                            data.endTime = nEndTime;
                            data.loop = hasLoop;
                            data.thumbImage = capturePath;

                            updateHighlight(r);
                            resolve('ok');
                        }
                    }
                })
            })
        })
    }

    /**
     * 设置是否有结束时间或者loop
     * @param note
     */
    const setTimeUpdateCallbackLoop = (note)=>{
        if (videoOtherContentRef.current && endTime){
            let nStartTimeSeconds = getSeconds(note.time);
            let nEndTimeSeconds = getSeconds(endTime);
            videoOtherContentRef.current?.onSetTimeUpdateCallback(nStartTimeSeconds,nEndTimeSeconds,hasLoop)
        }
    }

    /**
     * 截图----
     */
    const captureVideo = async ()=>{
        let szBase64:any = '';
        if (capturePath){
            //删除之前的.
            ipcInvoke('delete-files-file',{fileName:capturePath});
        }

        if (youtubeRef.current){

        }else if (localVideoRef.current){
            szBase64 = getVideoSnapShotByVideo(localVideoRef.current);
        }else if (videoOtherContentRef.current){
            szBase64 = await videoOtherContentRef.current.onGetVideoThumb();
        }
        if (szBase64){
            const szPath = await ipcInvoke('write-base64-image',{fileName:generateUUID2()+'.png',imgBase64:szBase64});
            setCapturePath(szPath);
        }
    }

    /**
     * 截图菜单....
     */
    const getCaptureMenu = ()=>{
        return [
            getItem(t("Replace"), 'replace', null, undefined, undefined, async () => {
                captureVideo();
            }),
            getItem(t("Copy to clipboard"), 'copyToClipboard', null, undefined, undefined, async () => {
                copyImageToClipboard(capturePath);
            }),
            getItem(t("Delete"), 'delete', null, undefined, undefined, () => {
                ipcInvoke('delete-files-file',{fileName:capturePath});
                setCapturePath('');
            }),
        ]
    }

    return(
        <Modal width={700} bodyStyle={{height: '660px', fontSize: '12px'}} open={isShowDialog} centered={true}
               afterClose={() => {
                   saveToDb();
                   if (props.onClose) {
                       props.onClose();
                   }
               }}
               closable={false} closeIcon={<IconClose/>} footer={null}
               onCancel={() => setIsShowDialog(false)}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <img className={'img-26 mr-4'} style={{marginTop:'-2.5px'}} src={getImagePathWithTheme('dialog_highlight')}/>
                    <span className={'dialog-title span-single-line mr-16'}>{annoData?.name || t("Untitled")}</span>
                    <div style={{flexGrow: '1'}}/>
                    <img className={'img-26 cursor-pointer'} style={{}} src={getImagePathWithTheme('dialog_anno_location')}
                         onClick={async () => {
                             await saveToDb();

                             const highlight = await dbGetHighlight(annoData.libraryId);
                             if (highlight) {
                                 window.showVideoNotes(highlight,annoData.id)
                             }
                             //关了这个，老是显示在下面...
                             setIsShowDialog(false);
                         }}/>
                    <img className={'img-26 cursor-pointer ml-6'} src={getImagePathWithTheme('dialog_anno_info')}
                         onClick={async () => {
                             await saveToDb();
                             window.showInfo('library', annoData);
                         }}/>
                    <Dropdown overlayClassName='default-dropdown-style'
                              menu={{items: arrayMenu,onClick:handleMenuClick}}
                              trigger={['click']}>
                        <img className={'img-26 ml-6 cursor-pointer'} style={{marginRight:'-10px'}}
                             src={getImagePathWithTheme('dialog_anno_more')}/>
                    </Dropdown>

                </div>

                <div style={{height:'12px',minHeight:'12px'}}></div>

                {
                    // isYoutubeUrl(annoData?.src?.link) &&
                    // <div  style={{ display: "block",background:'black',overflow:'hidden',width:'100%',height:'60%'}}>
                    //     <YouTube
                    //         className="you-tube-container"
                    //         videoId={annoData.src.videoId}
                    //         opts={{}}
                    //         onPlay={(event)=>{
                    //             console.log('xxxxx');
                    //         }}
                    //         onReady={onPlayerReadyYoutube}
                    //         style={{ display: "block",background:'black',objectFit:'contain',width:'100%',height:'100%'}}
                    //     />
                    // </div>
                }

                {
                    // isBilibiliUrl(annoData?.src) &&
                    isSupportVideoAnnoUrl(annoData?.src) &&
                    <div style={{ display: "block",background:'black',overflow:'hidden',width:'100%',height:'60%'}}>
                        <VideoOtherContent ref={videoOtherContentRef} url={annoData.src} seekTime={getSeconds(annoData?.time)}/>
                    </div>
                }

                {
                    videoData && videoData.type == 'video' &&
                    <video ref={localVideoRef} onCanPlay={onPlayerReadyLocal} onPlay={(event) => {
                        pauseAllVideo(event.target);
                    }} onTimeUpdate={(e)=>{
                        //是否存在结束时间
                        if (endTime){
                            const nEndTimeSeconds = getSeconds(endTime);
                            if(localVideoRef.current?.currentTime > (nEndTimeSeconds + 1)){
                                localVideoRef.current.currentTime = getSeconds(annoData.time);
                                if (hasLoop){
                                    localVideoRef.current.play();
                                }else{
                                    //结束
                                    localVideoRef.current?.pause();
                                }
                            }
                        }
                    }} style={{background: 'black', objectFit: 'contain', width: '100%', height: '60%'}} controls
                           src={getLocalFilePath(videoData.fileName, videoData.isAbsolutePath)}/>
                }

                {
                    videoData && videoData.type == 'audio' &&
                    <div style={{width:'100%',height:'100px'}}>
                        <CustomAudio ref={customAudioRef} szUrl={getLocalFilePath(videoData.fileName,videoData.isAbsolutePath)} from={FROM_DIALOG}/>
                    </div>

                }

                <div className={'flex-row-vertical-center'} style={{marginTop:'16px'}}>
                    <Input className={'input-border'} ref={txtTitleRef} style={{padding: "0 12px"}} value={annoData?.title} onChange={(e)=>{
                        var newData = {...annoData};
                        newData.title = e.currentTarget.value;
                        setAnnoData(newData);
                    }}/>
                    <TimePicker
                        variant={'borderless'}
                        className={'input-border'}
                        style={{height: '32px', marginLeft: '16px',background:'transparent',color:'var(--text-color)',minWidth:'180px'}}
                        showNow={false}
                        value={dayjs(annoData?.time)}
                        suffixIcon={<img className={'img-16'} src={imgPathPerfix() + 'time_icon.png'}/>}
                        // disabledTime={() => disabledTime.current}
                        onChange={onChangeTimePicker}
                    />
                    <Popover arrow={false} open={isPopoverEndTimeOpen} align={{offset:[-74,3]}} onOpenChange={(e)=>setIsPopoverEndTimeOpen(e)} zIndex={MAX_Z_INDEX} overlayInnerStyle={{padding:'0',margin:'0'}} trigger={['click']} placement={"bottom"} content={<div style={{width:'180px',minHeight:'156px',padding:'6px 16px 16px 16px'}}>
                        <div className={'flex-row-vertical-center video-more-item'}>
                            <span>{t("End time")}</span>
                            <Switch style={{width: '32px',marginLeft:'auto'}} value={endTime != 0} onChange={async (e) => {
                                if (!e) {
                                    setEndTime(0);
                                    setHasLoop(false);
                                }else {
                                    let duration = 0;
                                    if (localVideoRef.current) {
                                        duration = localVideoRef.current!.duration;
                                    }else if (youtubeRef.current) {
                                        duration = youtubeRef.current.getDuration();
                                    }else if (videoOtherContentRef.current) {
                                        duration = await videoOtherContentRef.current.onGetVideoTime();
                                    }
                                    const {currentHours, currentMinutes, currentSeconds} =
                                        getCurrentHoursMinutesSeconds(duration);
                                    const timePickerValue = getSpecificTimeOfDay(
                                        Math.floor(currentHours),
                                        Math.floor(currentMinutes),
                                        Math.floor(currentSeconds),
                                    );
                                    setEndTime(timePickerValue);
                                }
                            }}/>
                        </div>
                        {
                            endTime != 0 &&
                            <TimePicker
                                variant={'borderless'}
                                className={'input-border'}
                                style={{
                                    height: '32px',
                                    background: 'transparent',
                                    color: 'var(--text-color)',
                                    width: '100%',
                                }}
                                value={(endTime)}
                                showNow={false}
                                suffixIcon={<img className={'img-16'} src={imgPathPerfix() + 'time_icon.png'}/>}
                                // disabledTime={() => disabledTime.current}
                                onChange={(e)=>{
                                    setEndTime(e);
                                }}
                            />
                        }
                        <div className={'flex-row-vertical-center video-more-item'}>
                            <span>{t("Loop")}</span>
                            <Switch value={hasLoop} style={{width: '32px',marginLeft:'auto'}} onChange={(e) => {
                                if (endTime) {
                                    setHasLoop(e);
                                }else {
                                    setHasLoop(false);
                                }
                            }}/>
                        </div>
                        <div className={'flex-center mt-8'}>
                            <Button
                                className='button-solid-style font-size-14 font-family-medium border-radius-8'
                                type="primary"
                                style={{minWidth:'90px',height:'32px'}}
                                onClick={() => {
                                    setIsPopoverEndTimeOpen(false);
                                }}>{t("Ok")}</Button>
                        </div>

                    </div>}>
                        <div className={'video-v-more flex-center cursor-pointer ml-12'}>
                            <img className={'img-16'} src={getImagePathWithTheme('anno_video_v_more')}/>
                        </div>
                    </Popover>
                </div>

                <textarea ref={txtContentRef} className={'input-border'}
                          style={{resize:'none',flexGrow:'1',padding:'12px',marginTop:'12px',color:'var(--text-color)'}}
                          value={annoData?.content} onChange={(e)=> {
                              var newData = {...annoData};
                              newData.content = e.currentTarget.value;
                              setAnnoData(newData);
                }}></textarea>

                {
                    !capturePath && !isAudio(videoData?.fileName) &&
                    <div className={'div-item-container mt-12'} onClick={async ()=>{
                        captureVideo();
                    }}>
                        <img className={'img-16'} src={getImagePathWithTheme('video_capture')}/>
                    </div>
                }
                {
                    capturePath &&
                    <div style={{
                        position:'relative',
                       marginTop:'12px',
                        width: '78px',
                        height: '44px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        cursor:'pointer'
                    }} onMouseEnter={() => {
                        setIsMouseEnterCapture(true);
                    }} onMouseLeave={() => {
                        setIsMouseEnterCapture(false);
                    }} >
                        <img style={{
                            width: '78px',
                            height: '44px',
                            objectFit:'cover'
                        }} src={getLocalFilePath(capturePath,false)} />

                        {
                            isMouseEnterCapture &&
                            <>
                                <div style={{
                                    background: '#00000033',
                                    height: '100%',
                                    width: '100%',
                                    position: 'absolute',
                                    left: '0',
                                    top: '0',
                                }} onClick={()=>{
                                    window.showImagePreviewWithFullUrl(getLocalFilePath(capturePath,false));
                                }}></div>

                                <Dropdown trigger={['click']} menu={{items: getCaptureMenu()}}>
                                    <img className={'img-16 cursor-pointer'} style={{position: 'absolute', top: '6px', right: '6px'}}
                                         src={getImagePathWithTheme('video_capture_more')}/>
                                </Dropdown>
                            </>

                        }
                    </div>
                }

            </div>
        </Modal>
    )
})

export default DialogVideoAnno;